
import Relay from 'react-relay';
import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, IntlShape} from 'react-intl';
import {renderProgress} from './JobView.react';
import types from '../../common/model-api/types';
import {STATUS_FINISHED, STATUS_FAILED} from '../../common/model-api/JobType';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

interface JobProgressProps {
 intl: IntlShape;
 relay: object;
 user: User;
}

class JobProgress extends React.Component<JobProgressProps> {
    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    static typeName = 'jobs';

    componentDidMount() {
        let {job} = this.props.user;

        if (job.status !== STATUS_FINISHED && job.status !== STATUS_FAILED) {
            this.refreshTask = setInterval(() => {
                this.props.relay.forceFetch();
            }, 2000);
        }
    }

    componentWillUnmount() {
        if (this.refreshTask) {
            clearInterval(this.refreshTask);
        }
    }

    render() {
        let type = types[JobProgress.typeName];
        let {job} = this.props.user;

        if (this.refreshTask && (job.status === STATUS_FINISHED || job.status === STATUS_FAILED)) {
            clearInterval(this.refreshTask);
        }

        return renderProgress(type, this.props.user.job, this.props.intl.formatMessage);
    }
}

export default Relay.createContainer(injectIntl(JobProgress), {
    initialVariables: {
        organisationId: '',
        jobId: ''
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                job(id: $jobId) {
                    id,
                    realId,
                    progress,
                    status
                }
            }
        `
    }
});
